var StepStatus = /* @__PURE__ */ ((StepStatus2) => {
  StepStatus2["PAST"] = "past";
  StepStatus2["PRESENT"] = "present";
  StepStatus2["FUTURE"] = "future";
  return StepStatus2;
})(StepStatus || {});
const WsTimelineStepEnum = {
  Status: StepStatus
};
export {
  StepStatus,
  WsTimelineStepEnum,
  WsTimelineStepEnum as default
};
//# sourceMappingURL=WsTimelineStep.enum.es.js.map
